import {Component, ElementRef} from '@angular/core';

@Component({
    selector: 'vui-data-grid-fields',
    templateUrl: './data-grid-fields.component.html',
    styleUrls: ['./data-grid-fields.component.scss']
})
export class DataGridFieldsComponent {
    constructor(public elementRef: ElementRef) {

    }
}
